import Img from 'gatsby-image'

// ---------------------------------------------------------------------
// POLICY
// ---------------------------------------------------------------------

// export const fragPolicy = graphql`
//   fragment policy on PrismicCtPolicydoc {
//     uid
//     id
//     data {
//       title {
//         html
//         text
//       }
//       subtitle {
//         html
//         text
//       }
//       body {
//         primary {
//           text {
//             html
//             text
//           }
//         }
//       }
//     }
//   }
// `

// ---------------------------------------------------------------------
// DOC
// ---------------------------------------------------------------------

export const fragDoc = graphql`
  fragment doc on PrismicCtDoc {
    uid
    id
    data {
      title {
        html
        text
      }
      subtitle {
        html
        text
      }
      body {
        items {
          para {
            html
            text
          }
        }
      }
    }
  }
`

// ---------------------------------------------------------------------
// CUSTOMTER
// ---------------------------------------------------------------------

export const fragCustomer = graphql`
  fragment customer on PrismicCtCustomer {
    uid
    id
    data {
      title {
        html
        text
      }
      logo {
        localFile {
          childImageSharp {
            sizes(maxWidth: 300) {
              ...GatsbyImageSharpSizes
            }
            original {
              src
            }
          }
        }
        url
        alt
      }
    }
  }
`

// ---------------------------------------------------------------------
// SERVICE
// ---------------------------------------------------------------------

export const fragService = graphql`
  fragment service on PrismicCtService {
    uid
    id
    data {
      service_headline {
        html
        text
      }
      service_subtitle {
        html
        text
      }
      service_timestamp
      logo {
        localFile {
          childImageSharp {
            original {
              src
            }
            sizes(maxWidth: 420) {
              ...GatsbyImageSharpSizes
            }
          }
        }
        url
      }
      banner_logo {
        localFile {
          childImageSharp {
            original {
              src
            }
            sizes(maxWidth: 1240) {
              ...GatsbyImageSharpSizes
            }
          }
        }
        url
      }
      lead_title {
        html
        text
      }
      lead_summary {
        html
        text
      }
      meta_title {
        html
        text
      }
      meta_description {
        html
        text
      }
      body {
        __typename
        ... on PrismicCtServiceBodyServiceContent {
          slice_type
          items {
            section_title {
              html
              text
            }
            section_subtitle {
              html
              text
            }
            section_text {
              html
              text
            }
            section_image {
              localFile {
                childImageSharp {
                  sizes(maxWidth: 1240) {
                    ...GatsbyImageSharpSizes
                  }
                  original {
                    src
                  }
                }
              }
              url
              alt
            }
          }
        }
        __typename
        ... on PrismicCtServiceBodyServiceQuote {
          slice_type
          primary {
            quote_text {
              html
              text
            }
            quote_author {
              html
              text
            }
          }
        }
        __typename
        ... on PrismicCtServiceBodyServiceContentLink {
          slice_type
          items {
            content_link {
              document {
                __typename
                ... on PrismicCtServiceFocus {
                  uid
                  type
                  data {
                    title {
                      html
                      text
                    }
                    image {
                      localFile {
                        childImageSharp {
                          sizes(maxWidth: 1000, quality: 80) {
                            ...GatsbyImageSharpSizes
                          }
                          original {
                            src
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      meta_title {
        text
      }
      meta_description {
        text
      }
      og_title {
        text
      }
      og_description {
        text
      }
      og_type {
        text
      }
    }
  }
`

// ---------------------------------------------------------------------
// SERVICE FOCUS
// ---------------------------------------------------------------------
export const fragServiceFocus = graphql`
  fragment serviceFocus on PrismicCtServiceFocus {
    uid
    id
    type
    data {
      service_type
      headline {
        text
      }
      title {
        text
      }
      image {
        localFile {
          childImageSharp {
            sizes(maxWidth: 1200) {
              ...GatsbyImageSharpSizes
            }
            original {
              src
            }
          }
        }
      }
      body {
        __typename
        ... on PrismicCtServiceFocusBodyText {
          slice_type
          primary {
            section_image {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                  sizes(maxWidth: 1240) {
                    ...GatsbyImageSharpSizes
                  }
                }
              }
            }
          }
          items {
            section_text {
              html
            }
          }
        }
        __typename
        ... on PrismicCtServiceFocusBodyContentLink {
          slice_type
          items {
            content_link {
              document {
                __typename
                ... on PrismicCtBlog {
                  type
                  uid
                  data {
                    title {
                      html
                      text
                    }
                    image {
                      localFile {
                        childImageSharp {
                          sizes(maxWidth: 1024) {
                            ...GatsbyImageSharpSizes
                          }
                          original {
                            src
                          }
                        }
                      }
                    }
                  }
                }
                __typename
                ... on PrismicCtStudy {
                  type
                  uid
                  data {
                    title {
                      html
                      text
                    }
                    image {
                      localFile {
                        childImageSharp {
                          sizes(maxWidth: 1024) {
                            ...GatsbyImageSharpSizes
                          }
                          original {
                            src
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      meta_title {
        text
      }
      meta_description {
        text
      }
      og_title {
        text
      }
      og_description {
        text
      }
      og_type {
        text
      }
    }
  }
`

// ---------------------------------------------------------------------
// BLOG
// ---------------------------------------------------------------------

export const fragBlog = graphql`
  fragment blog on PrismicCtBlogs {
    data {
      title {
        html
        text
      }
      subtitle {
        html
        text
      }
      featured_blog {
        document {
          ...post
        }
      }
      featured_blog_background {
        localFile {
          childImageSharp {
            sizes(maxWidth: 1280) {
              ...GatsbyImageSharpSizes
            }
            original {
              src
            }
          }
        }
        alt
        url
      }
      body {
        __typename
        ... on PrismicCtBlogsBodyBlogList {
          slice_type
          items {
            blog_background {
              url
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
            blog_existing {
              document {
                ...post
              }
            }
          }
        }
        __typename
        ... on PrismicCtBlogsBodyBlogQuote {
          primary {
            quote_text {
              html
              text
            }
            quote_author {
              html
              text
            }
          }
        }
      }
      meta_title {
        text
      }
      meta_description {
        text
      }
      og_title {
        text
      }
      og_description {
        text
      }
      og_type {
        text
      }
    }
  }
`

// ---------------------------------------------------------------------
// POST
// ---------------------------------------------------------------------

export const fragPost = graphql`
  fragment post on PrismicCtBlog {
    uid
    id
    tags
    data {
      inline_videos {
        document {
          ...video
        }
      }
      background_videos {
        document {
          ...video
        }
      }
      image {
        localFile {
          childImageSharp {
            sizes(maxWidth: 1240) {
              ...GatsbyImageSharpSizes
            }
            original {
              src
            }
          }
        }
        alt
        url
      }
      thumbnail {
        localFile {
          childImageSharp {
            sizes(maxWidth: 512) {
              srcSet
            }
            original {
              src
            }
          }
        }
        url
      }
      display_date
      title {
        html
        text
      }
      subtitle {
        html
        text
      }
      lead {
        html
        text
      }
      author {
        document {
          data {
            author_name {
              html
              text
            }
            author_role {
              html
              text
            }
            author_photo {
              url
            }
          }
        }
      }
      body {
        __typename
        ... on PrismicCtBlogBodyBlogQuote {
          primary {
            quote_text {
              html
              text
            }
            quote_author {
              html
              text
            }
          }
        }
        __typename
        ... on PrismicCtBlogBodyBlogSection {
          primary {
            section_image {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                  sizes(maxWidth: 1240) {
                    ...GatsbyImageSharpSizes
                  }
                }
              }
              url
            }
          }
          items {
            section_title {
              html
              text
            }
            section_subtitle {
              html
              text
            }
            section_text {
              html
              text
            }
          }
        }
        __typename
        ... on PrismicCtBlogBodyVideoSlice {
          primary {
            video {
              document {
                ...video
              }
            }
            video_title {
              html
              text
            }
            video_subtitle {
              html
              text
            }
          }
        }
      }
      meta_title {
        text
      }
      meta_description {
        text
      }
      og_title {
        text
      }
      og_description {
        text
      }
      og_type {
        text
      }
    }
  }
`

// ---------------------------------------------------------------------
// STUDIES
// ---------------------------------------------------------------------

export const fragStudies = graphql`
  fragment studies on PrismicCtStudies {
    data {
      title {
        html
        text
      }
      subtitle {
        html
        text
      }
      featured_study {
        document {
          ...study
        }
      }
      featured_study_background {
        url
        localFile {
          childImageSharp {
            original {
              src
            }
          }
        }
      }
      body {
        __typename
        ... on PrismicCtStudiesBodyStudyList {
          slice_type
          items {
            study_background {
              url
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
            study_existing {
              document {
                ...study
              }
            }
          }
        }
        __typename
        ... on PrismicCtStudiesBodyStudyQuote {
          slice_type
          primary {
            quote_text {
              html
              text
            }
            quote_author {
              html
              text
            }
          }
        }
      }
      meta_title {
        text
      }
      meta_description {
        text
      }
      og_title {
        text
      }
      og_description {
        text
      }
      og_type {
        text
      }
    }
  }
`

// ---------------------------------------------------------------------
// STUDY
// ---------------------------------------------------------------------

export const fragStudy = graphql`
  fragment study on PrismicCtStudy {
    uid
    id
    data {
      customer {
        document {
          ...customer
        }
      }
      background_videos {
        document {
          ...video
        }
      }
      inline_videos {
        document {
          ...video
        }
      }
      image {
        localFile {
          childImageSharp {
            sizes(maxWidth: 1240) {
              ...GatsbyImageSharpSizes
            }
            original {
              src
            }
          }
        }
        url
      }
      display_date
      title {
        html
        text
      }
      subtitle {
        html
        text
      }
      lead {
        html
        text
      }
      body {
        __typename
        ... on PrismicCtStudyBodyLinks {
          ...links
        }

        __typename
        ... on PrismicCtStudyBodyStudyQuote {
          ...quote
        }

        __typename
        ... on PrismicCtStudyBodyStudySection {
          primary {
            section_image {
              localFile {
                childImageSharp {
                  sizes(maxWidth: 1240) {
                    ...GatsbyImageSharpSizes
                  }
                  original {
                    src
                  }
                }
              }
              url
              alt
            }
          }
          items {
            section_title {
              html
              text
            }
            section_subtitle {
              html
              text
            }
            section_text {
              html
              text
            }
          }
        }
      }
      meta_title {
        text
      }
      meta_description {
        text
      }
      og_title {
        text
      }
      og_description {
        text
      }
      og_type {
        text
      }
    }
  }
`

// ---------------------------------------------------------------------
// CAREERS
// ---------------------------------------------------------------------

export const fragCareers = graphql`
  fragment careers on PrismicCtCareers {
    data {
      title {
        html
        text
      }
      subtitle {
        html
        text
      }
      video {
        url
      }
      videos {
        document {
          ...video
        }
      }
      body {
        items {
          career_existing {
            document {
              ...career
            }
          }
        }
      }
      meta_title {
        text
      }
      meta_description {
        text
      }
      og_title {
        text
      }
      og_description {
        text
      }
      og_type {
        text
      }
    }
  }
`

// ---------------------------------------------------------------------
// CONTACT
// ---------------------------------------------------------------------

export const fragContact = graphql`
  fragment contact on PrismicCtContact {
    uid
    data {
      title {
        html
        text
      }
      subtitle {
        html
        text
      }
      image {
        url
        localFile {
          childImageSharp {
            original {
              src
            }
            sizes(maxWidth: 640) {
              ...GatsbyImageSharpSizes
            }
          }
        }
      }
      body {
        __typename
        ... on PrismicCtContactBodyChannels {
          slice_type
          primary {
            heading {
              html
              text
            }
          }
          items {
            channel {
              html
              text
            }
            contact {
              html
              text
            }
            type
          }
        }
        __typename
        ... on PrismicCtContactBodyOffice {
          slice_type
          primary {
            heading {
              html
              text
            }
          }
          items {
            location {
              html
              text
            }
            address {
              html
              text
            }
            telephone {
              html
              text
            }
            theme
          }
        }
        __typename
        ... on PrismicCtContactBodyTextBlock {
          slice_type
          primary {
            heading {
              html
              text
            }
            content {
              html
              text
            }
          }
        }
        __typename
        ... on PrismicCtContactBodyPromotion {
          slice_type
          primary {
            icon {
              url
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                  sizes(maxWidth: 300) {
                    ...GatsbyImageSharpSizes
                  }
                }
              }
            }
            heading {
              html
              text
            }
            link {
              document {
                uid
                type
                data {
                  title {
                    html
                    text
                  }
                  subtitle {
                    html
                    text
                  }
                }
              }
            }
            link_text {
              html
              text
            }
          }
        }
      }
      meta_title {
        html
        text
      }
      meta_description {
        html
        text
      }
      og_type {
        html
        text
      }
      og_title {
        html
        text
      }
      og_description {
        html
        text
      }
    }
  }
`

// ---------------------------------------------------------------------
// CAREER
// ---------------------------------------------------------------------

export const fragCareer = graphql`
  fragment career on PrismicCtCareer {
    uid
    id
    data {
      filter_type
      filter_location
      role {
        html
        text
      }
      description {
        html
        text
      }
      details {
        html
        text
      }
      contact {
        html
        text
      }
      meta_title {
        text
      }
      meta_description {
        text
      }
      og_title {
        text
      }
      og_description {
        text
      }
      og_type {
        text
      }
    }
  }
`

// ---------------------------------------------------------------------
// ABOUT US
// ---------------------------------------------------------------------

export const fragAbout = graphql`
  fragment about on PrismicCtAbout {
    uid
    data {
      image_bg {
        localFile {
          childImageSharp {
            original {
              src
            }
            sizes(maxWidth: 1200) {
              ...GatsbyImageSharpSizes
            }
          }
        }
        url
      }
      title {
        html
        text
      }
      subtitle {
        html
        text
      }
      metric_title {
        html
        text
      }
      metrics {
        metric {
          html
          text
        }
        value {
          html
          text
        }
      }
      image {
        localFile {
          childImageSharp {
            original {
              src
            }
            sizes(maxWidth: 1200) {
              ...GatsbyImageSharpSizes
            }
          }
        }
        url
      }
      heading {
        html
        text
      }
      content {
        html
        text
      }
      videos {
        document {
          ...video
        }
      }
      links_title {
        html
        text
      }
      links {
        link {
          html
          text
        }
        url {
          raw {
            uid
          }
        }
      }
      meta_title {
        text
      }
      meta_description {
        text
      }
      og_title {
        text
      }
      og_description {
        text
      }
      og_type {
        text
      }
    }
  }
`

// ---------------------------------------------------------------------
// VIDEO
// ---------------------------------------------------------------------

export const fragVideo = graphql`
  fragment video on PrismicCtVideo {
    data {
      title {
        html
        text
      }
      url_hls3 {
        url
      }
      url_dash {
        url
      }
      hls4 {
        url
      }
      poster {
        url
        localFile {
          childImageSharp {
            original {
              src
            }
            sizes(maxWidth: 1280) {
              ...GatsbyImageSharpSizes
            }
          }
        }
      }
    }
  }
`

// ---------------------------------------------------------------------
// THING
// ---------------------------------------------------------------------

export const fragThing = graphql`
  fragment thing on PrismicCtThing {
    uid
    data {
      thing_type
      logo {
        localFile {
          childImageSharp {
            original {
              src
            }
            sizes(maxWidth: 250) {
              ...GatsbyImageSharpSizes
            }
          }
        }
        url
      }
      title {
        html
        text
      }
      subtitle {
        html
        text
      }
      intro_title {
        html
        text
      }
      intro {
        html
        text
      }
      body {
        __typename
        ... on PrismicCtThingBodyBlock {
          items {
            block_title {
              html
              text
            }
            block_text {
              html
              text
            }
          }
        }
        __typename
        ... on PrismicCtThingBodyQuote {
          primary {
            quote {
              html
              text
            }
            author {
              html
              text
            }
          }
        }
        __typename
        ... on PrismicCtThingBodyVideo {
          primary {
            video_link {
              document {
                ...video
              }
            }
          }
        }
        __typename
        ... on PrismicCtThingBodyEyecandy {
          primary {
            eyecandy_title {
              html
              text
            }
            eyecandy_text {
              html
              text
            }
          }
          items {
            candy_title {
              html
              text
            }
            candy_text {
              html
              text
            }
            candy_image {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                  sizes(maxWidth: 500) {
                    ...GatsbyImageSharpSizes
                  }
                }
              }
              url
            }
          }
        }
        __typename
        ... on PrismicCtThingBodyTakeaways {
          primary {
            takeaway_title {
              html
              text
            }
            takeaway_text {
              html
              text
            }
          }
          items {
            download_title {
              html
              text
            }
            download_text {
              html
              text
            }
            download {
              url
            }
          }
        }
      }
    }
  }
`
// ---------------------------------------------------------------------
// METHOD
// ---------------------------------------------------------------------

export const fragMethod = graphql`
  fragment method on PrismicCtMethod {
    data {
      type
      headline {
        html
        text
      }
      subtitle {
        html
        text
      }
      lead {
        html
        text
      }
      background_video {
        document {
          ...video
        }
      }
      background_image {
        localFile {
          childImageSharp {
            sizes(maxWidth: 1240) {
              ...GatsbyImageSharpSizes
            }
            original {
              src
            }
          }
        }
        url
      }
      gradient
      body {
        __typename
        ... on PrismicCtMethodBodyImage {
          slice_type
          items {
            image {
              localFile {
                childImageSharp {
                  sizes(maxWidth: 2048) {
                    ...GatsbyImageSharpSizes
                  }
                  original {
                    src
                  }
                }
              }
              url
            }
          }
        }

        __typename
        ... on PrismicCtMethodBodyContentLink {
          slice_type
          id
          primary {
            title1 {
              html
              text
            }
            subtitle1 {
              html
              text
            }
          }
          items {
            content_link {
              document {
                __typename
                ... on Node {
                  __typename
                  ... on PrismicCtShot {
                    uid
                    type
                    data {
                      title: headline {
                        html
                        text
                      }
                      image: background_image {
                        localFile {
                          childImageSharp {
                            sizes(maxWidth: 200) {
                              ...GatsbyImageSharpSizes
                            }
                            original {
                              src
                            }
                          }
                        }
                        url
                      }
                    }
                  }
                  __typename
                  ... on PrismicCtBlog {
                    uid
                    type
                    data {
                      title: title {
                        html
                        text
                      }
                      image: image {
                        localFile {
                          childImageSharp {
                            sizes(maxWidth: 200) {
                              ...GatsbyImageSharpSizes
                            }
                            original {
                              src
                            }
                          }
                        }
                        url
                      }
                    }
                  }
                  __typename
                  ... on PrismicCtStudy {
                    uid
                    type
                    data {
                      title: title {
                        html
                        text
                      }
                      image: image {
                        localFile {
                          childImageSharp {
                            sizes(maxWidth: 200) {
                              ...GatsbyImageSharpSizes
                            }
                            original {
                              src
                            }
                          }
                        }
                        url
                      }
                    }
                  }
                  __typename
                  ... on PrismicCtShot {
                    uid
                    type
                    data {
                      title: headline {
                        html
                        text
                      }
                      image: background_image {
                        localFile {
                          childImageSharp {
                            sizes(maxWidth: 200) {
                              ...GatsbyImageSharpSizes
                            }
                            original {
                              src
                            }
                          }
                        }
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }

        __typename
        ... on PrismicCtMethodBodyBoxes {
          slice_type
          id
          primary {
            step {
              html
              text
            }
            title {
              html
              text
            }
            subtitle {
              html
              text
            }
          }
          items {
            row
            column
            title {
              html
              text
            }
            lead {
              html
              text
            }
            description {
              html
              text
            }
          }
        }
        __typename
        ... on PrismicCtMethodBodyContact {
          slice_type
          id
          primary {
            type
            step {
              html
              text
            }
            title {
              html
              text
            }
            subtitle {
              html
              text
            }
            lead {
              html
              text
            }
          }
        }
        __typename
        ... on PrismicCtMethodBodyQuote {
          slice_type
          id
          primary {
            quote {
              html
              text
            }
            author {
              html
              text
            }
            company {
              html
              text
            }
          }
        }

        __typename
        ... on PrismicCtMethodBodyList {
          slice_type
          primary {
            step {
              html
              text
            }
            title {
              html
              text
            }
            subtitle1 {
              html
              text
            }
            lead1 {
              html
              text
            }
          }
          items {
            image {
              localFile {
                childImageSharp {
                  sizes(maxWidth: 200) {
                    ...GatsbyImageSharpSizes
                  }
                  original {
                    src
                  }
                }
              }
              url
            }
            title {
              html
              text
            }
            subtitle1 {
              html
              text
            }
            lead1 {
              html
              text
            }
            link {
              document {
                __typename
                __typename
                ... on PrismicCtShot {
                  ...shot
                }
                __typename
                ... on PrismicCtServiceFocus {
                  ...serviceFocus
                }
              }
            }
          }
        }
      }
    }
  }
`
// ---------------------------------------------------------------------
// SHOT
// ---------------------------------------------------------------------

export const fragShot = graphql`
  fragment shot on PrismicCtShot {
    id
    uid
    data {
      headline {
        html
        text
      }
      subtitle {
        html
        text
      }
      lead {
        html
        text
      }
      background_video {
        document {
          ...video
        }
      }
      background_image {
        localFile {
          childImageSharp {
            sizes(maxWidth: 1900) {
              ...GatsbyImageSharpSizes
            }
            original {
              src
            }
          }
        }
        url
      }
      gradient
      body {
        __typename
        ... on PrismicCtShotBodyImage {
          slice_type
          items {
            image {
              localFile {
                childImageSharp {
                  sizes(maxWidth: 2048) {
                    ...GatsbyImageSharpSizes
                  }
                  original {
                    src
                  }
                }
              }
              url
            }
          }
        }

        __typename
        ... on PrismicCtShotBodyQuote {
          slice_type
          primary {
            author {
              html
              text
            }
            quote {
              text
            }
            company {
              text
            }
          }
        }
        __typename
        ... on PrismicCtShotBodyContent {
          slice_type
          id
          primary {
            title {
              html
              text
            }
            subtitle1 {
              html
              text
            }
          }
          items {
            image {
              localFile {
                childImageSharp {
                  sizes(maxWidth: 200) {
                    ...GatsbyImageSharpSizes
                  }
                  original {
                    src
                  }
                }
              }
              url
            }
            title {
              html
              text
            }
            subtitle1 {
              html
              text
            }
            content {
              html
              text
            }
          }
        }
        __typename
        ... on PrismicCtShotBodyContentLink {
          slice_type
          id
          primary {
            title1 {
              html
              text
            }
            subtitle1 {
              html
              text
            }
          }
          items {
            content_link {
              document {
                __typename
                ... on Node {
                  __typename
                  ... on PrismicCtMethod {
                    uid
                    type
                    data {
                      title: headline {
                        html
                        text
                      }
                      image: background_image {
                        localFile {
                          childImageSharp {
                            sizes(maxWidth: 200) {
                              ...GatsbyImageSharpSizes
                            }
                            original {
                              src
                            }
                          }
                        }
                        url
                      }
                    }
                  }
                  __typename
                  ... on PrismicCtBlog {
                    uid
                    type
                    data {
                      title: title {
                        html
                        text
                      }
                      image: image {
                        localFile {
                          childImageSharp {
                            sizes(maxWidth: 200) {
                              ...GatsbyImageSharpSizes
                            }
                            original {
                              src
                            }
                          }
                        }
                        url
                      }
                    }
                  }
                  __typename
                  ... on PrismicCtStudy {
                    uid
                    type
                    data {
                      title: title {
                        html
                        text
                      }
                      image: image {
                        localFile {
                          childImageSharp {
                            sizes(maxWidth: 200) {
                              ...GatsbyImageSharpSizes
                            }
                            original {
                              src
                            }
                          }
                        }
                        url
                      }
                    }
                  }
                  __typename
                  ... on PrismicCtShot {
                    uid
                    type
                    data {
                      title: headline {
                        html
                        text
                      }
                      image: background_image {
                        localFile {
                          childImageSharp {
                            sizes(maxWidth: 200) {
                              ...GatsbyImageSharpSizes
                            }
                            original {
                              src
                            }
                          }
                        }
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
        __typename
        ... on PrismicCtShotBodyContact {
          slice_type
          id
          primary {
            type
            title {
              html
              text
            }
            subtitle {
              html
              text
            }
            lead {
              html
              text
            }
          }
        }
      }
    }
  }
`

// ---------------------------------------------------------------------
// LINKS
// ---------------------------------------------------------------------

export const fragLinks = graphql`
  fragment links on PrismicCtStudyBodyLinks {
    primary {
      title {
        html
        text
      }
      subtitle {
        html
        text
      }
      lead {
        html
        text
      }
    }
    items {
      title {
        html
        text
      }
      subtitle {
        html
        text
      }
      lead {
        html
        text
      }
      link {
        document {
          uid
        }
      }
    }
  }
`

// ---------------------------------------------------------------------
// Quote
// ---------------------------------------------------------------------

export const fragQuote = graphql`
  fragment quote on PrismicCtStudyBodyStudyQuote {
    primary {
      quote_text {
        html
        text
      }
      quote_author {
        html
        text
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/utils/fragments.js